'use server'

import { createClient, createServiceClient } from '@repo/db/server'
import { normalizeInvitationEmail } from '@/lib/invitations'
import { hasInvitationMailer, invitationAppUrl, sendInvitationMail } from '@/lib/invitations-mail'

export async function updateEmail(newEmail: string, currentPassword?: string) {
  const supabase = await createClient()
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) return { error: 'Oturum bulunamadı' }

  if (!currentPassword) return { error: 'Mevcut şifrenizi girin.' }
  if (!user.email) return { error: 'Hesabın e-posta adresi bulunamadı.' }
  let email: string
  try { email = normalizeInvitationEmail(newEmail) } catch { return { error: 'Geçerli bir e-posta adresi gerekli.' } }
  if (email === user.email.trim().toLowerCase()) {
    return { error: 'Yeni e-posta mevcut e-posta ile aynı.' }
  }

  const { data: verified, error: passwordError } = await supabase.auth.signInWithPassword({ email: user.email, password: currentPassword })
  if (passwordError || verified.user?.id !== user.id) return { error: 'Mevcut şifre hatalı.' }
  if (!hasInvitationMailer()) return { error: 'E-posta gönderimi yapılandırılmamış. Adres değiştirilmedi.' }
  try {
    const admin = createServiceClient()
    const options = { redirectTo: invitationAppUrl('/admin/hesabim') }
    // GoTrue SMTP yok: doğrulama tokenlarını üret, uygulama mailer'ıyla gönder.
    // Her iki adresin bağlantısı aynı doğrulanmış hesaba ait olmalı.
    const current = await admin.auth.admin.generateLink({ type: 'email_change_current', email: user.email, newEmail: email, options })
    if (current.error || current.data.user?.id !== user.id || !current.data.properties?.action_link) throw new Error('Doğrulama oluşturulamadı.')
    const next = await admin.auth.admin.generateLink({ type: 'email_change_new', email: user.email, newEmail: email, options })
    if (next.error || next.data.user?.id !== user.id || !next.data.properties?.action_link) throw new Error('Doğrulama oluşturulamadı.')
    await sendInvitationMail(user.email, 'E-posta değişikliğini onaylayın', `E-posta değişikliğini onaylamak için:\n${current.data.properties.action_link}`)
    await sendInvitationMail(email, 'Yeni e-posta adresinizi doğrulayın', `Yeni adresinizi doğrulamak için:\n${next.data.properties.action_link}`)
    return { success: true, message: 'Doğrulama bağlantıları gönderildi. E-posta adresiniz doğrulama tamamlandıktan sonra değişir.' }
  } catch {
    return { error: 'Doğrulama e-postası gönderilemedi. Adres değişimi tamamlanmadı; daha sonra yeniden deneyin.' }
  }
}

export async function updatePassword(currentPassword: string, newPassword: string) {
  const supabase = await createClient()
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) return { error: 'Oturum bulunamadı' }

  if (newPassword.length < 6) {
    return { error: 'Şifre en az 6 karakter olmalıdır.' }
  }

  // Mevcut şifreyi doğrula
  const { error: signInError } = await supabase.auth.signInWithPassword({
    email: user.email!,
    password: currentPassword,
  })

  if (signInError) {
    return { error: 'Mevcut şifre hatalı.' }
  }

  const { error } = await supabase.auth.updateUser({ password: newPassword })
  if (error) return { error: error.message }

  return { success: true, message: 'Şifreniz başarıyla güncellendi.' }
}
